import { DeliveryModel } from '@audibene/ta.utils-opportunity'

const deliveryModelToDisplayText: Partial<Record<DeliveryModel, string>> = {
  TA_LIGHT: 'TA Light',
  TELEAUDIOLOGY: 'Teleaudiology',
}

export { deliveryModelToDisplayText }
